/* global angular */
import { Filter } from '../common/filter';

export class RouterService {
  constructor(
    $location,
    $rootScope,
    CurrentFilterService,
    FiltersService,
    PermissionService,
    CurrentModelService,
    $q,
    ErrorHandlerService,
    CurrentFilterDataService,
    FrameLoadService,
  ) {
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.CurrentFilterService = CurrentFilterService;
    this.FiltersService = FiltersService;
    this.PermissionService = PermissionService;
    this.CurrentModelService = CurrentModelService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.FrameLoadService = FrameLoadService;
    // this.$rootScope.$on('$routeChangeError', (error) => {
    //   console.error(error);
    // });
    // this.$rootScope.$on('$routeChangeStart', (error) => {
    //   console.log('$routeChangeStart');
    // });
    // this.$rootScope.$on('$routeChangeSuccess', (error) => {
    //   console.log('$routeChangeSuccess');
    // });
    this.$rootScope.$on('$routeUpdate', () => {
      // console.log('$routeUpdate');
      this.update();
      this.CurrentFilterDataService.reload();
    });
    this.initialized = false;
  }

  init() {
    if (this.initialized) {
      console.error('initialize already in progress');
      return;
    }
    this.initialized = false;
    return this.$q
      .all([
        this.CurrentModelService.load(),
        this.FiltersService.load(),
      ])
      .then(() => {
        this.update();
        return this.CurrentFilterDataService.reload();
      })
      .then(() => {
        if (window.first_start) {
          this.openFrame('/admin/agent/config/1/');
          window.first_start = false;
        }
      })
      .then(() => {
        this.$rootScope.$broadcast('init');
      })
      .then(() => {
        return this.FrameLoadService.waitUntilLoad();
      })
      .catch(error => {
        this.ErrorHandlerService.handle(error);
      })
      .finally(() => {
        this.initialized = true;
        setTimeout(() => {
          // notify html2pdf that document is ready
          window.status = 'INIT_COMPLETE';
          console.log('staffcop init complete');
        }, 1000);
      });
  }

  home() {
    // this.search({});
    window.location = '/';
  }

  /**
   * update state from url
   */
  update() {
    let state = this.$location.search();
    this.validate(state);
    if (state.timeFrom) {
      this.CurrentFilterService.timeFrom = state.timeFrom;
    }
    if (state.timeTo) {
      this.CurrentFilterService.timeTo = state.timeTo;
    }
    if (state.panel) {
      this.CurrentFilterService.panel = state.panel;
    }
    if (state.threshold) {
      this.CurrentFilterService.threshold = state.threshold;
    }

    let setFilter = false;
    if (typeof state.id !== 'undefined') {
      const id = Number(state.id);
      if (id && !isNaN(id)) {
        let filter = this.FiltersService.findById(id);
        if (filter) {
          this.CurrentFilterService.filter = angular.copy(filter);
          setFilter = true;
        }
      }
    }
    if (!this.CurrentFilterService.filter) {
      if (this.CurrentFilterService.panel === 'constructor' || !this.FiltersService.filters.length) {
        this.CurrentFilterService.newFilter();
      } else {
        if (this.FiltersService.filters.length) {
          this.CurrentFilterService.filter = angular.copy(
            this.FiltersService.filters[0]);
        } else {
          console.error('no one filter found');
        }
      }
    } else {
      if (!setFilter) {
        this.CurrentFilterService.newFilter();
      }
    }
    if (this.CurrentFilterService.filter) {
      this.updateFilter(state);
      this.updateFilterChildren(this.CurrentFilterService.filter);
      if (setFilter && !this.CurrentFilterService.filter._changed && !state.panel) {
        this.CurrentFilterService.panel = 'catalog';
      }
    }
    this.CurrentFilterService.selectBarDim(state.barDim ||
      this.CurrentFilterService.defaultDimension);
    if (state.lookup) {
      this.CurrentFilterService.filterBar.lookup = state.lookup;
    } else {
      this.CurrentFilterService.filterBar.lookup = '';
    }
    if (state.frameUrl) {
      this.CurrentFilterService.openFrame(state.frameUrl);
    } else {
      this.CurrentFilterService.reset();
    }
  }

  updateFilter(state) {
    let changed = false;
    if (state.drilldown) {
      this.CurrentFilterService.filter.drilldown = state.drilldown.split(',');
      changed = true;
    }
    if (state.filters) {
      try {
        this.CurrentFilterService.filter.filters = JSON.parse(state.filters);
        changed = true;
      }
      catch (error) {
        console.error('parse filters route parameter');
      }
    }
    if (state.query) {
      try {
        this.CurrentFilterService.filter.query = JSON.parse(state.query);
        changed = true;
      }
      catch (error) {
        console.error('parse query route parameter');
      }
    }
    if (state.measure) {
      this.CurrentFilterService.filter.measure = state.measure;
      changed = true;
    }
    if (state.mode) {
      this.CurrentFilterService.filter.mode = state.mode;
      changed = true;
    }
    if (state.threshold) {
      this.CurrentFilterService.filter.threshold = state.threshold;
      changed = true;
    }
    if (state.url) {
      this.CurrentFilterService.filter.url = state.url;
      changed = true;
    }
    if (state.listType) {
      this.CurrentFilterService.filter.listType = state.listType;
      changed = true;
    }
    this.CurrentFilterService.filter._changed = changed;
    if (this.CurrentFilterService.filter.isCard) {
      this.CurrentFilterService.buildCardFilter();
    }
  }

  updateFilterChildren(filter) {
    filter.children.forEach(child => this.updateFilterChild(filter, child));
  }

  updateFilterChild(parent, child) {
    child.timeFrom = parent.timeFrom;
    child.timeTo = parent.timeTo;
    if (this.CurrentFilterService.filter.isCard) {
      parent.filters.forEach((f) => child.removeFilter(f.dimension, f.value));
      child.filters = child.filters.concat(parent.filters);
    }
    this.updateFilterChildren(child);
  }

  /**
   * filter out invalid keys
   * @param state
   */
  validate(state) {
    state.timeFrom = Filter.urlToDate(state.timeFrom);
    state.timeTo = Filter.urlToDate(state.timeTo);
    if (!this.PermissionService.filterConstructor) {
      if (state.panel === 'constructor') {
        state.panel = 'catalog';
      }
    }
  }

  set panel(panel) {
    this.search('panel', panel);
  }

  set timeTo(timeTo) {
    this.search('timeTo', Filter.dateToUrl(timeTo));
  }

  set timeFrom(timeFrom) {
    this.search('timeFrom', Filter.dateToUrl(timeFrom));
  }

  set threshold(threshold) {
    this.search('threshold', threshold);
  }

  set filter(filter) {
    let query = this.search();
    this.clearFilter(query);
    let originalFilter;
    if (filter.id) {
      query.id = filter.id;
      originalFilter = this.FiltersService.findById(filter.id);
    } else {
      originalFilter = new Filter();
    }
    if (filter.isAnomaly()) {
      query.threshold = filter.threshold;
    } else {
      delete query.threshold;
    }
    if (!angular.equals(filter.drilldown, originalFilter.drilldown)) {
      query.drilldown = filter.drilldown.join(',');
    }
    if ((!filter.filters || !filter.filters.length) && originalFilter.filters && originalFilter.filters.length ||
      (!originalFilter.filters || !originalFilter.filters.length) && filter.filters && filter.filters.length ||
      filter.filters && filter.filters.length &&
      originalFilter.filters && originalFilter.filters.length &&
      !angular.equals(filter.filters, originalFilter.filters)) {
      query.filters = angular.toJson(filter.filters);
    }
    if (filter.hasQuery !== originalFilter.hasQuery ||
      !angular.equals(filter.query, originalFilter.query)) {
      query.query = angular.toJson(filter.query);
    }
    if (filter.measure !== originalFilter.measure) {
      query.measure = filter.measure;
    }
    if (filter.isReports() && filter.url !== originalFilter.url) {
      query.url = filter.url;
    }
    if (filter.mode !== originalFilter.mode) {
      query.mode = filter.mode;
    }
    if (filter.isExplore() && filter.listType !== originalFilter.listType) {
      query.listType = filter.listType;
    }
    if (this.CurrentFilterService.frameUrl) {
      query.frameUrl = this.CurrentFilterService.frameUrl;
    }
    this.search(query);
  }

  set barDim(dim) {
    this.search('barDim', dim);
    this.search('lookup', null);
  }

  setFilter(dimension, value, label) {
    this.CurrentFilterService.filter.setFilter(dimension, value, label);
    this.CurrentFilterService.filter.mode = 'explore';
    this.CurrentFilterService.rebuildVisibleDimensions();
    this.filterChanged();
  }

  toggleFilter(filter) {
    this.CurrentFilterService.filter.toggleFilter(filter);
    this.CurrentFilterService.filter.mode = 'explore';
    this.CurrentFilterService.rebuildVisibleDimensions();
    this.filterChanged();
  }

  removeConditions() {
    this.search('query', 'null');
  }

  drilldownFilter(dimension, value, label) {
    if (!value && !label) {
      this.CurrentFilterService.filter.toggleFilter(dimension);
    } else {
      this.CurrentFilterService.filter.toggleFilter({dimension, value, label});
    }
    this.CurrentFilterService.filter.mode = 'explore';
    delete this.CurrentFilterService.filter.id;
    this.CurrentFilterService.rebuildVisibleDimensions();
    this.filterChanged();
  }

  addFilter(...args) {
    this.CurrentFilterService.filter.addFilter(...args);
    this.filterChanged();
  }

  addTimeFilter(...args) {
    this.CurrentFilterService.filter.addTimeFilter(...args);
    this.filterChanged();
  }

  removeFilter(...args) {
    this.CurrentFilterService.filter.removeFilter(...args);
    this.filterChanged();
  }

  invertFilter(...args) {
    this.CurrentFilterService.filter.invertFilter(...args);
    this.filterChanged();
  }

  addKeyword(keywords) {
    this.CurrentFilterService.filter.addKeyword(keywords);
    this.filterChanged();
  }

  set mode(mode) {
    this.panel = 'constructor';
    this.search('mode', mode);
    this.search('frameUrl', null);
  }

  set listType(mode) {
    this.search('listType', mode);
  }

  setMeasure(measure) {
    this.CurrentFilterService.filter.measure = measure;
    this.filterChanged();
  }

  selectFilter(id) {
    let query = Object.assign({}, this.$location.search());
    this.clearFilter(query);
    query.id = id;
    if (angular.equals(this.$location.search(), query)) {
      let filter = this.FiltersService.findById(id);
      this.CurrentFilterService.filter = angular.copy(filter);
      this.CurrentFilterDataService.reload();
      return;
    }
    this.search(query);
  }

  clearFilter(query) {
    delete query.id;
    delete query.drilldown;
    delete query.filters;
    delete query.query;
    delete query.measure;
    delete query.mode;
    delete query.url;
    delete query.listType;
    delete query.frameUrl;
  }

  resetFilter() {
    let query = this.search();
    let id = query.id;
    this.clearFilter(query);
    if (id) {
      query.id = id;
    }
    this.search(query);
  }

  onDeleteFilter() {
    let query = this.search();
    this.clearFilter(query);
    this.search(query);
  }

  selectDim(dim) {
    if (this.CurrentFilterService.filter.hasDrilldown(dim.toString())) {
      return;
    }
    this.CurrentFilterService.filter.addDrilldown(dim.toString());
    this.CurrentFilterService.filter.changed();
    this.search('frameUrl', null);
    this.filterChanged();
  }

  removeDim(dim) {
    if (!this.CurrentFilterService.filter.hasDrilldown(dim.toString())) {
      return;
    }
    this.CurrentFilterService.filter.removeDrilldown(dim.toString());
    this.CurrentFilterService.filter.changed();
    this.filterChanged();
  }

  drilldown(dim) {
    if (dim.dimension || dim.is_flat) {
      this.CurrentFilterService.filterBar.drill = dim.toString();
      this.filterChanged();
    }
  }

  lookup(value) {
    this.search('lookup', value || null);
  }

  generateReport(...args) {
    this.CurrentFilterService.generateReport(...args);
    this.filterChanged();
    this.search('frameUrl', null);
  }

  openFrame(url) {
    this.search('frameUrl', url);
  }

  openNewWindow(more) {
    if (typeof(more) !== 'string') {
      more = '';
    }
    let src = this.CurrentFilterService.frameUrl ||
      this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
    window.open(src + more, '_new');
  }

  filterChanged() {
    this.filter = this.CurrentFilterService.filter;
  }

  frameChanged() {
    if (this.CurrentFilterService.frameUrl) {
      this.search('frameUrl', this.CurrentFilterService.frameUrl);
    } else {
      this.search('frameUrl', null);
    }
  }

  newFilter() {
    this.panel = 'constructor';
    this.CurrentFilterService.frameUrl = null;
    this.filter = this.CurrentFilterService.createNewFilter();
  }

  openCard(filterCut) {
    let query = this.search();
    query.mode = 'reports';
    query.url = '/analytics/card/';
    query.filters = angular.toJson([filterCut]);
    query.drilldown = [filterCut.dimension].join(',');
    delete query.frameUrl;
    delete query.id;
    this.search(query);
  }

  search(...args) {
    return this.$location.search(...args);
  }
}



// WEBPACK FOOTER //
// ./src/core/router.service.js